import { Card as MuiCard } from "@material-ui/core";
import { styled } from "@material-ui/styles";

const Card = styled(MuiCard)({
  margin: 20,
});

export default Card;
